function getCookie(cname) {
  const name = cname + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function populateDateOfBirth(klaviyoFormBirthDateInput) {
  let dateOfBirthInput = klaviyoFormBirthDateInput;
  if (dateOfBirthInput) {
    let birthDate = getCookie("birthDate");

    if (birthDate) {
      klaviyoFormBirthDateInput.focus();
      if (klaviyoFormBirthDateInput.value === "") {
        setTimeout(() => {
          simulateTyping(birthDate, klaviyoFormBirthDateInput);
        }, 100);
      }
    } else {
      document.querySelector(
        `.klaviyo-form-UUDBAu [data-testid="form-row"]:has([id*="age_gated_date_of_birth"])`
      ).classList.add("show-form-row");
    }
  }
}

function simulateTyping(strContent, objElement, intSpeed = 20) {
  // ******************************
  // Initialize Variables
  // ******************************
  var intIndex = 0;

  // ******************************
  // Define Function That Performs The Data Entry Itself
  //		Recursively Calls Itself To Continue Typing All Content
  // ******************************
  function funcTypeNextCharacter() {
    if (intIndex < strContent.length) {
      const event = new Event("input", { bubbles: true });
      objElement.value += strContent.charAt(intIndex);
      objElement.dispatchEvent(event);
      const keyEvent = new KeyboardEvent("keydown", {
        key: strContent.charAt(intIndex),
        bubbles: true,
      });
      objElement.dispatchEvent(keyEvent);

      intIndex++;
      setTimeout(funcTypeNextCharacter, intSpeed);
    }
  }

  // ******************************
  // Start The Recursive Call To Write Out Supplied Content
  // ******************************
  funcTypeNextCharacter();
}

const observer = new MutationObserver((mutations, obs) => {
  const klaviyoForm = document.querySelector(".klaviyo-form-UUDBAu");
  const klaviyoFormBirthDateInput = klaviyoForm.querySelector(
    'input[id*="age_gated_date_of_birth"]'
  );
  const klaviyoFormPhoneInput = klaviyoForm.querySelector('input[type="tel"]');

  if (klaviyoFormBirthDateInput && klaviyoFormPhoneInput) {
    obs.disconnect();
    // Form is now loaded and available

    setTimeout(() => {
      populateDateOfBirth(klaviyoFormBirthDateInput);
    }, 100);
  }
});

observer.observe(document.querySelector(".klaviyo-form-UUDBAu"), {
  childList: true,
  subtree: true,
});


function handlePopupDesignMode() {
  const popupContainer = document.querySelector('.popup');
  if (Shopify.designMode) {
    popupContainer.style.display = 'none';
    document.body.style.overflow = 'auto';

    document.addEventListener('shopify:section:select', (event) => {
      if (event.target.id.includes('shopify-section-popup')) {
        popupContainer.style.display = 'block';
        document.body.style.overflow = 'hidden';
      }
    });

    document.addEventListener('shopify:section:deselect', (event) => {
      if (event.target.id.includes('shopify-section-popup')) {
        popupContainer.style.display = 'none';
        document.body.style.overflow = 'auto';
      }
    });
  }
}
handlePopupDesignMode();